import { Box, Typography } from "@mui/material";
import { ConfirmDialog, IconButton } from "bi-lib";
import { useState } from "react";
import ActiveIndicator from "./active-indicator.tsx";

interface Props {
    isActive: boolean;
    onClick?: () => void;
    onActivate?: () => void;
    onDeactivate?: () => void;
    activateLabel?: string;
    deactivateLabel?: string;
}

export default function ActivateDeactivateButton({
    isActive,
    onClick,
    onActivate,
    onDeactivate,
    activateLabel,
    deactivateLabel,
}: Props) {
    const [confirmAction, setConfirmAction] = useState<() => void>();

    const handleActivate = () => {
        onClick?.();
        onActivate?.();
    };

    const handleDeactivate = () => {
        onClick?.();
        onDeactivate?.();
    };

    if (onClick != undefined || (onActivate != undefined && !isActive) || (onDeactivate != undefined && isActive)) {
        return (
            <>
                <ConfirmDialog
                    onConfirm={confirmAction!}
                    onClose={() => setConfirmAction(() => undefined)}
                    open={confirmAction != undefined}
                >
                    <Typography>
                        Are you sure you want to{" "}
                        <Typography fontWeight={"bold"} display={"inline"} component={"span"}>
                            {isActive ? "deactivate" : "activate"}
                        </Typography>{" "}
                        this?
                    </Typography>
                </ConfirmDialog>
                <IconButton
                    tooltip={isActive ? (deactivateLabel ?? "Deactivate") : (activateLabel ?? "Activate")}
                    onClick={() => setConfirmAction(() => (isActive ? handleDeactivate : handleActivate))}
                >
                    <ActiveIndicator isActive={isActive} />
                </IconButton>
            </>
        );
    }

    return (
        <Box p={1}>
            <ActiveIndicator isActive={isActive} />
        </Box>
    );
}
